import templateUrl from './icd-work-order-payout-breakdown.component.html'

export const IcdWorkOrderPayoutBreakdownComponent = {
    controller: IcdWorkOrderPayoutBreakdownController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        workOrderPayout: "<"
    }
};

function IcdWorkOrderPayoutBreakdownController() {
    const vm = this;

    vm.$onInit = onInit;
    vm.payoutSum = payoutSum;
    vm.repPayoutSum = repPayoutSum;
    vm.productOrderLimit = 10;
    vm.showMoreProductOrders = function () {
        vm.productOrderLimit += 10
    };

    function onInit() {
    }

    function payoutSum(payouts) {
        return !payouts ? 0 : payouts.reduce(function (sum, payout) {
            return sum + payout.PayoutAmount;
        }, 0);
    }

    function repPayoutSum(payouts) {
        return !payouts ? 0 : payouts.reduce(function (sum, payout) {
            return sum + payout.SuggestedRepPayoutAmount;
        }, 0);
    }
}
